<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint || !!postId" :use-tab-codes="['workplace-material']" field-name="사업장명"/>

    <!-- 시설물 유지 예산 정보 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>시설물 유지 예산 정보</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8" style="border:1px solid #cdcdcd;">
        <vs-col>
          <ul class="table table-7" style="border-bottom:none;">
            <li class="header header-bg grid-row">
              <span>항목별</span>
              <span>예산 편성</span>
              <span>추경</span>
              <span>상반기 집행액</span>
              <span>하반기 집행액</span>
              <span>누계</span>
              <span>집행률</span>
            </li>

            <!-- 안전보건인건비 -->
            <li class="grid-row" v-for="item in form.budgetInfo" :key="item.label">
              <span class="header-bg">{{ item.label }}</span>

              <!-- 예산 편성 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.budget }}</span>
                <comma-input v-else class="w-full" v-model="item.budget" :readonly="board.readonly" />
              </span>

              <!-- 추경 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.supplement }}</span>
                <comma-input v-else class="w-full" v-model="item.supplement" :readonly="board.readonly" />
              </span>

              <!-- 상반기 집행액 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.firstHalf }}</span>
                <comma-input v-else class="w-full" v-model="item.firstHalf" :readonly="board.readonly" />
              </span>

              <!-- 하반기 집행액 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ item.secondHalf }}</span>
                <comma-input v-else class="w-full" v-model="item.secondHalf" :readonly="board.readonly" />
              </span>

              <!-- 누계 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ uiRowCalculateTotal(item) }}</span>
                <comma-input v-else class="w-full" :value="uiRowCalculateTotal(item)" :readonly="true"/>
              </span>

              <!-- 집행률 -->
              <span>
                <span class="isPrint" v-if="isPrint">{{ uiRowCalculateRate(item) }}</span>
                <ml-input v-else class="w-full" :value="uiRowCalculateRate(item)" :readonly="true"/>
              </span>
            </li>

            <!-- 누계 -->
            <li class="grid-row">
              <span class="header-bg">누계</span>
              <span>
                <span class="isPrint" v-if="isPrint">{{form.totalBudget.budget}}</span>
                <comma-input v-else class="w-full" :value="form.totalBudget.budget" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{form.totalBudget.supplement}}</span>
                <comma-input v-else class="w-full" :value="form.totalBudget.supplement" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{form.totalBudget.firstHalf}}</span>
                <comma-input v-else class="w-full" :value="form.totalBudget.firstHalf" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{form.totalBudget.secondHalf}}</span>
                <comma-input v-else class="w-full" :value="form.totalBudget.secondHalf" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{uiRowCalculateTotal(form.totalBudget)}}</span>
                <comma-input v-else class="w-full" :value="uiRowCalculateTotal(form.totalBudget)" :readonly="true"/>
              </span>
              <span>
                <span class="isPrint" v-if="isPrint">{{uiRowCalculateRate(form.totalBudget)}}</span>
                <ml-input v-else class="w-full" :value="uiRowCalculateRate(form.totalBudget)" :readonly="true"/>
              </span>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    totalInputB () {
      return this.computeInputTotal(this.form.inputB)
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))];
    },
    postId() {
      return parseInt(this.$route.params.postId);
    }
  },
  watch: {
    value: {
      deep: true,
      async handler (value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              const formData = value[key]

              this.form[key] = formData
            }
          }
        }
      }
    },

    form: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    },

    'form.budgetInfo': {
      deep: true,
      handler (value) {
        const totalBudget = {label: '누계', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0}
        for (const item of this.form.budgetInfo) {
          totalBudget.budget += Number(this.removeComma(item.budget))
          totalBudget.supplement += Number(this.removeComma(item.supplement))
          totalBudget.firstHalf += Number(this.removeComma(item.firstHalf))
          totalBudget.secondHalf += Number(this.removeComma(item.secondHalf))
        }
        this.form.totalBudget = totalBudget
      }
    }
  },
  data () {
    return {
      form: {
        stdInfo:{},
        fileList: [],
        budgetInfo: [
          {label: '유해위험 점검 비용', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0, },
          {label: '유해위험 안전조치 비용', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0, },
          {label: '교육·훈련 비용', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0, },
          {label: '기타 안전예산', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0, },
        ],
        totalBudget: {label: '누계', budget: 0, supplement: 0, firstHalf:0, secondHalf: 0}
      },
    }
  },
  mounted () {
  },
  methods: {
    uiRowCalculateTotal(item) {
      return Number(this.removeComma(item.firstHalf)) + Number(this.removeComma(item.secondHalf))
    },
    uiRowCalculateRate(item) {
      // 집행률 = (상반기 집행액 + 하반기 집행액) / (예산편성 + 추경) * 100
      const 사용금액 = Number(this.removeComma(item.firstHalf)) + Number(this.removeComma(item.secondHalf))
      const 예산 = Number(this.removeComma(item.budget)) + Number(this.removeComma(item.supplement))
      if (예산 === 0) {
        return 0
      }
      const rate = Math.floor(사용금액 * 10000.0 / 예산) / 100.0
      return rate.toFixed(2)
    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma (str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    }
  },
}
</script>

<style scoped>

</style>
